import { StyleSheet } from "@react-pdf/renderer";
export const primaryColorDark = '#114b67';
export const primaryColorLight = '#47b7d1';
export const lightInputTextFieldColor = '#e4f3fa';

export const textBoxFontFamily = 'Red Hat Display';
export const textBoxFontSize = 13;
export const styles = StyleSheet.create({
	pageNumber: {
		position: 'absolute',
		fontSize: 14,
		bottom: 10,
		left: 0,
		right: 0,
		textAlign: 'center',
		color: primaryColorDark,
		fontWeight: 700
	},
	page: {
		paddingTop: 40,
		paddingBottom: 25
	},
	subHeader: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0
	},
	icon: {
		width: '17px',
		height: '17px'
	},
	iconRowView: {
		position: 'absolute',
		bottom: 20,
		left: 0,
		right: 0,
		height: '30px'
	},
	iconRow: {
		display: 'flex',
		flexDirection: 'row',
		marginLeft: 18
	},
	iconText: {
		color: primaryColorDark,
		fontWeight: 400,
		fontSize: 11,
		paddingLeft: 5,
		paddingTop: 3
	},
	body: {
		paddingHorizontal: 5
	},
	title: {
		fontSize: 23,
		// textAlign: 'center',
		fontFamily: 'Red Hat Display',
		fontWeight: 900,
		color: primaryColorDark
	},
	logo: {
		height: '100px',
		width: '100px'
	},
	dot: {
		height: '10px',
		width: '10px'
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'nowrap',
		justifyContent: 'space-between'
	},
	view: {
		backgroundColor: '#e4f3fa'
	},
	image: {
		paddingTop: 23,
		paddingLeft: 10,
		minWidth: '200px'
	},
	textWrapper60: {
		flexBasis: 100,
		flexGrow: 10,
		paddingTop: 31,
		paddingRight: 15
	},
	textWrapper40: {
		flexBasis: 50,
		flexGrow: 6,
		paddingTop: 5,
		paddingRight: 20
	},
	divider: {
		borderLeft: 1.5,
		borderLeftColor: primaryColorDark,
		borderLeftStyle: 'solid',
		marginTop: 20,
		marginLeft: 10,
		marginRight: 10,
		height: '60px',
		flexGrow: 0.25,
		flexBasis: 10
	},
	infoText: {
		textAlign: 'left',
		fontSize: 13,
		flexBasis: 50,
		fontFamily: 'Red Hat Display',
		color: primaryColorDark,
		fontWeight: 400,
		paddingVertical: 7
	},
	textBoxSubtitle: {
		textAlign: 'left',
		paddingBottom: 4,
		paddingTop: 8,
		fontFamily: 'Red Hat Display',
		fontSize: 14,
		color: primaryColorDark,
		fontWeight: 700
	},
	textBox: {
		fontSize: 13,
		textAlign: 'left',
		fontFamily: 'Red Hat Display',
		color: primaryColorDark,
		fontWeight: 400,
		paddingHorizontal: 5
	},
	column: {
		flexDirection: 'column',
		justifyContent: 'space-between'
	},
	preparedForRow: {
		flexBasis: 20,
		flexGrow: 1
	},
	preparedForView: {
		backgroundColor: '#cae8f6',
		height: '65px'
	},
	header: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0
	},
	headermargin: {
		marginBottom: '50px'
	}
});
